export default { 
  apiKey: "AIzaSyBoW1b9VsnLPyn84DzQCiwEWdQY-fAoyxI",
  authDomain: "covidcare-fec86.firebaseapp.com",
  databaseURL: "https://covidcare-fec86.firebaseio.com",
  projectId: "covidcare-fec86",
  storageBucket: "covidcare-fec86.appspot.com",
  messagingSenderId: "334578585586",
  appId: "1:334578585586:web:9d7f43376d0bc9a5d3e56b",
  measurementId: "G-GBW6X0X9MM"
}